// /js/stores/customerBooking.js
import { defineStore } from 'pinia';
import Booking from '@/js/models/booking.js';
import { createBooking } from '@/js/apis/bookings.js';

/**
 * Customer Booking Store - Vitrina (simplified)
 * Only supports creating a new booking via POST.
 * No caches, no auth-gated reads, no offline support.
 */
export const useCustomerBookingStore = defineStore('customerBooking', {
  state: () => ({
    isLoading: false,
    error: null,
  }),

  actions: {
    /**
     * Create a new booking
     * @param {string|number} salonId - The 16-digit salon ID
     * @param {Object} bookingData - Booking payload with aliased field names
     * @returns {Promise<Booking|null>} Created booking or null on failure
     */
    async createBooking(salonId, bookingData) {
      this.isLoading = true;
      this.error = null;

      try {
        console.log('[customerBooking] Creating booking for salon:', salonId);
        const response = await createBooking(salonId, bookingData);

        if (response?.ok && response.data) {
          const newBooking = new Booking(response.data);
          console.log('[customerBooking] Booking created successfully');
          this.isLoading = false;
          return newBooking;
        } else {
          throw new Error(response?.error || 'Failed to create booking');
        }
      } catch (error) {
        console.error('[customerBooking] Error creating booking:', error);
        this.error = error.message || 'Failed to create booking';
        this.isLoading = false;
        return null;
      }
    },

    /**
     * Clear any previous error state
     */
    clearError() {
      this.error = null;
    },
  },
});
